import { useSelector } from 'react-redux';
import { selectUserAttributes } from '@features/auth/slice';

export function useIsMerchant(): boolean {
  const attrs = useSelector(selectUserAttributes);
  return attrs.entity?.some((v) => v?.toLowerCase() === 'merchant') ?? false;
}
